var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAffiliate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.9707V13.9707H22V11.9707H18ZM16 18.5807C16.96 19.2907 18.21 20.2307 19.2 20.9707C19.6 20.4407 20 19.9007 20.4 19.3707C19.41 18.6307 18.16 17.6907 17.2 16.9707C16.8 17.5107 16.4 18.0507 16 18.5807ZM20.4 6.5707C20 6.0407 19.6 5.5007 19.2 4.9707C18.21 5.7107 16.96 6.6507 16 7.3707C16.4 7.9007 16.8 8.4407 17.2 8.9707C18.16 8.2507 19.41 7.3207 20.4 6.5707ZM4 9.9707C2.9 9.9707 2 10.8707 2 11.9707V13.9707C2 15.0707 2.9 15.9707 4 15.9707H5V19.9707H7V15.9707H8L13 18.9707V6.9707L8 9.9707H4ZM9.03 11.6807L11 10.5007V15.4407L9.03 14.2607L8.55 13.9707H4V11.9707H8.55L9.03 11.6807ZM15.5 12.9707C15.5 11.6407 14.92 10.4407 14 9.6207V16.3107C14.92 15.5007 15.5 14.3007 15.5 12.9707Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliate);
export default __webpack_public_path__ + "static/media/affiliate.8e19a3dacc353f0dbea40d91cd39cf06.svg";
export { ForwardRef as ReactComponent };